var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("header", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("portal-target", {
            staticClass: "d-flex align-items-center mt-1",
            attrs: { name: "sidebar-toggle" }
          }),
          _vm._v(" "),
          _c("h4", { staticClass: "mb-0" }, [_vm._v("Отчёты")])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page-body" }, [
      _c(
        "div",
        { staticClass: "page-filters" },
        [
          _c(
            "b-collapse",
            {
              staticClass: "mt-0",
              attrs: { id: "collapse-filters", visible: "" }
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "span",
                  { staticClass: "mr-2" },
                  [
                    _c("b-form-input", {
                      staticClass: "mb-2 mr-sm-2 mb-sm-0",
                      attrs: {
                        size: "sm",
                        id: "input_startDate",
                        type: "date"
                      },
                      model: {
                        value: _vm.startDate,
                        callback: function($$v) {
                          _vm.startDate = $$v
                        },
                        expression: "startDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _c("b-form-input", {
                      staticClass: "mb-2 mr-sm-2 mb-sm-0",
                      attrs: { size: "sm", id: "input_endDate", type: "date" },
                      model: {
                        value: _vm.endDate,
                        callback: function($$v) {
                          _vm.endDate = $$v
                        },
                        expression: "endDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-3" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-list-group",
                    [
                      _c(
                        "b-list-group-item",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v(
                            "\n              Пользователи\n              "
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.onUsers }
                            },
                            [_vm._v("Скачать")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group-item",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v("\n              Заказчики\n              "),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.onCustomers }
                            },
                            [_vm._v("Скачать")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group-item",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v("\n              Объекты\n              "),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.onLocations }
                            },
                            [_vm._v("Скачать")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group-item",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v("\n              Исполнители\n              "),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.onWorkers }
                            },
                            [_vm._v("Скачать")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group-item",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v("\n              Заявки\n              "),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.onTasks }
                            },
                            [_vm._v("Скачать")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group-item",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v(
                            "\n              Исполнители в заявке\n              "
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.onTaskWorkers }
                            },
                            [_vm._v("Скачать")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-732a53cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732a53cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Reports.vue
// module id = null
// module chunks = 